<!-- -->
<template>
  <el-dialog v-model="visible" title="编辑物流" width="800px" :before-close="handleClose">
    <el-form class="mr20" ref="ruleForm" :model="addRow" label-width="100px">
      <form-item-rule label="物流名称" prop="itemDesc">
        <el-input class="w500" v-model="addRow.itemDesc"></el-input>
      </form-item-rule>
      <form-item-rule label="物流代码" prop="itemCode">
        <el-input class="w500" v-model="addRow.itemCode"></el-input>
      </form-item-rule>
      <form-item-rule label="排序" prop="sort">
        <el-input-number :min="0" class="w200" v-model="addRow.sort" placeholder="请输入排序"></el-input-number>
      </form-item-rule>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="doSave()">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import FormItemRule from "@/components/el/form-item-rule";
  export default {
    name: "express-add",
    components: {FormItemRule},
    data() {
      return {
        visible: false,
        addRow: {itemDesc: "", itemCode: "", sort: 0},
      }
    },
    mixins: [tableBase],
    methods: {
      handleClose() {
        this.visible = false;
      },
      open(row) {
        if (row) {
          this.addRow = this.copyObj(row);
        } else {
          this.addRow = {itemDesc: "", itemCode: "", sort: 0};
        }
        this.visible = true;
      },
      doSave() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            delete this.addRow.goods;
            delete this.addRow.itemList;
            this.simplePost("/api/mgr/sys/express/addOrUpdate", this.addRow, () => {
              this.handleClose();
              this.$emit('load')
              this.message("操作成功");
            })
          }
        })
      }
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>

</style>
